<template>
  <div class="event-page page">
    <template v-if="category && !loading && !is403Error">
      <component :is="categoryComponent" :data="category" />
    </template>

    <div class="event-page__loading page-loading" v-else-if="loading">
      {{ $t("services.loading") }}
    </div>

    <div class="event-page__loading page-loading" v-else-if="is403Error">
      {{ $t("services.error403") }}
    </div>
  </div>
</template>

<script>
import MainCategoryPage from "@/views/MainCategoryPage.vue";
import SubcategoryPage from "@/views/SubcategoryPage.vue";
import apiCategories from "@/api/categories";

export default {
  name: "CategoryPage",
  components: { MainCategoryPage, SubcategoryPage },
  data() {
    return {
      loading: false,
      category: {},
      is403Error: false
    };
  },
  created() {
    this.getCategory();
  },
  computed: {
    categoryComponent() {
      return this.category.parent_id ? SubcategoryPage : MainCategoryPage;
    },
    breadcrumbs() {
      return [
        {
          title: "Выставка",
          route: { name: "participant", params: { id: this.$route.params.id } }
        }
      ];
    }
  },
  methods: {
    async getCategory() {
      try {
        this.loading = true;
        let params = this.$route.params;
        const { data } = await apiCategories.getCategory(
          params.id,
          params.category_id
        );
        this.category = data;
      } catch (e) {
        this.is403Error = e.error_data?.response?.status === 403;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.main-category-page {
  &__popular-services {
    margin-top: 50px;
    @media (max-width: 540px) {
      margin-top: 30px;
    }
  }
}
</style>
